<template>
  <div class="content">
    <div class="bg">
      <div class="block">
        <div class="item">
          <span class="star">*</span>
          <p class="topic">
            <input class="enter" v-model="topic" type="text" :placeholder="`请输入${$_syscfg.interview}主题`" maxlength="60">
            <span class="count">{{`${topic.length}/60`}}</span>
          </p>
        </div>
        <div class="item">
          <span class="star">*</span>
          <div class="autoSelector">
            <div :class="{depart: true, on: showDepart, disableDepart: disableDepart}" @click="toggleDepart()">
              <span :class="{department: true, filled: selectedDep.title}">{{selectedDep.title || '请选择部门'}}</span>
              <img class="icon" :src="showDepart ? icons.up: icons.down" alt="arrow">
            </div>
            <div class="selections" v-if="showDepart">
              <p class="opt" v-for="(d, i) in deps" :key="i" @click="selectdep(d)">
                <span>{{d.title}}</span>
                <img v-if="d.id === selectedDep.id" src="@assets/img/interview/select.svg" alt="select">
              </p>
            </div>
          </div>
        </div>
        <div class="item">
          <span class="star">*</span>
          <date-picker v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" :type="'datetime'" :format="'YYYY-MM-DD HH:mm'" confirm></date-picker>
        </div>
        <div class="item">
          <span class="star">*</span>
          <div class="locate">
            <input type="text" v-model="locate" placeholder="请输入地址">
            <img class="icon" src="@assets/img/interview/locate.svg" alt="locate">
            <!-- <img class="icon" src="@assets/img/interview/locate.svg" alt="locate" @click="openLocation()"> -->
          </div>
        </div>
        <div class="item uploadItem">
          <span class="star placeholder"></span>
          <div class="attachment">
            <p class="attachmentTitle">
              添加附件
              <span>最多3张，仅支持jpg、png等图片格式</span>
            </p>
            <div class="attachmentList">
              <div class="attachmentItem" v-for="(a, i) in attachments" :key="i">
                <img :src="a.url" alt="attachment">
                <div class="progressMask" v-if="a.uploading">
                  <span class="progressBar"><i :style="{width: a.progress + '%'}"></i></span>
                  <span class="progressText">{{ a.progress }}%</span>
                </div>
                <div class="failMask" v-if="a.failed" @click="retryRegister(i)">
                  <span class="failIcon">!</span>
                  <span class="failText">入库失败<br>点击重试</span>
                </div>
                <img class="del" src="@assets/img/interview/attachmentDel.png" alt="del" @click="removeAttachment(i)">
              </div>
              <div class="attachmentAdd" v-show="attachments.length < 3" @click="triggerUpload()">
                <i></i>
              </div>
              <!-- 分片上传挂载点：Upload 类会向其注入隐藏的 <input type="file"> -->
              <div id="itvUploadBtn" class="uploadMount"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="block">
        <p class="title">
          {{`${$_syscfg.interview}需求`}}
        </p>
        <div class="item">
          <span class="star">*</span>
          <div class="autoSelector">
            <div :class="{reporter: true, on: focusInputing}">
              <span v-show="s.selected" class="selectd" v-for="(s, i) in reporters" :key="i">
                <span>{{s.name}}</span>
                <img class="close" src="@assets/img/interview/del.svg" alt="close" @click="unSelectReporter(s)">
              </span>
              <input class="enter" type="text" placeholder="请选择记者" @focus="focusInput" @blur="blurInput()" v-model="reporter" @keyup="searchReporters()">
              <img src="@assets/img/interview/reporter.svg" alt="reporter">
            </div>
            <div class="selections" v-if="focusInputing">
              <p class="opt" v-for="(r, d) in reporters" :key="d" @mousedown="selectReporter(r)" v-show="!r.hide">
                <span>{{r.name}}</span>
                <img v-if="r.selected" src="@assets/img/interview/select.svg" alt="select">
              </p>
            </div>
          </div>
        </div>
        <div class="item" v-for="(b, i) in bases" :key="i">
          <p class="category">
            {{b.rc_name}}
          </p>
          <counter v-on:getValue="getBaseCounter" :name="b.rc_name" :now="b.num - 0" :max="b.max_num - 0" />
        </div>
        <div class="remark">
          <textarea v-model="remark" class="enter" :placeholder="`${$_syscfg.interview}备注`" maxlength="200"></textarea>
          <p class="count">{{`${remark.length}/200`}}</p>
        </div>
      </div>
      <div class="block">
        <p class="title">
          拓展类设备
        </p>
        <div class="equipContainer">
          <div class="equipment" v-for="(e, i) in expands" :key="i">
            <p class="category">
              {{e.rc_name}}
            </p>
            <counter v-on:getValue="getSubCounter" :name="e.rc_name" :now="e.num - 0" :max="e.max_num - 0" />
          </div>
        </div>
      </div>
      <!-- <div class="block" v-if="enableAssociate">
        <p class="title">
          {{`关联${$_syscfg.topic}`}}
        </p>
        <div class="linkTopic">
          <p class="linkBtn" @click="openLink()">
            <img src="@assets/img/interview/link.svg" alt="link">
            <span>{{`关联${$_syscfg.topic}`}}</span>
          </p>
          <span :class="{linkMsg: true, linked: associate.title}">{{associate.title || `仅可关联1条${$_syscfg.topic}`}}</span>
        </div>
      </div> -->
    </div>
    <div class="footLine" :style="{width: `calc(100vw - ${footLineGap}px)`}">
      <span :class="{'btn': true, 'disabled': posting}" v-if="showModify" @click="updateDetail()">修改</span>
      <span :class="{'btn': true, 'ml20': true, 'disabled': posting}" v-if="showModify" @click="updateAndApprove()">修改并通过</span>
      <span :class="{'btn': true, 'disabled': posting}" v-if="showRelease" @click="updateDetail()">提交</span>
      <span class="btn gray" @click="goBack()">取消</span>

      <div v-if="has_topic_power && topicExist" :class="{autoPost: true, autoPostOn: autoPost.on}" @click="switchAutoPost()">
        <img :src="autoPost.on?autoPost.icons.on:autoPost.icons.off" alt="checker">
        <span>{{`同时生成一条选题`}}</span>
      </div>
    </div>
    <withTopic :from="1" ref="withTopic" @getTopic="getLink" />
    <!-- <location ref="location" @getLocation="getLocate" /> -->
    <div class="lock" v-if="lock.show">
      <p class="msg">{{`该稿件已被锁定，正在被${lock.locker}编辑`}}</p>
    </div>
    <successTip ref="successTip" />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import counter from '@components/counter'
import withTopic from '@components/withTopic'
import location from '@components/location'
import common from '@common/common'
import {apis} from '@common/config'
import successTip from '@components/successTip'
import {createImageUploader, cancelRemoteUpload} from '@common/newUploadConfig'

export default {
  name: 'editInterview',
  components: {
    DatePicker, counter, withTopic, location, successTip
  },
  data() {
    return {
      has_topic_power: false,
      topicExist: false,
      autoPost: {
        icons: {
          on: require("@assets/img/common/autoCheckerOn.svg"),
          off: require("@assets/img/common/autoChecker.svg")
        },
        on: false
      },
      icons: {
        up: require('@assets/img/interview/up.svg'),
        down: require('@assets/img/interview/down.svg')
      },
      topic: '',
      showDepart: false,
      datePicker: '',
      locate: '',
      reporter: '',
      reporters: [],
      deps: [],
      selectedDep: {},
      focusInputing: false,
      remark: '',
      expands: [],
      bases: [],
      associate: {},
      showRelease: false,
      showModify: false,
      disableDepart: false,
      enableAssociate: false, // 是否显示关联策划
      lock: {
        locker: '',
        show: false,
        time: 15*1000,
        interval: null
      },
      id: '',
      posting: false,
      footLineGap: 230,
      attachments: [],
      itvUpload: null
    }
  },
  methods: {
    async switchAutoPost() {
      if (!this.autoPost.on) {
        this.$toast('当前采访通过后，将自动生成一条选题，可前往对应模块查看！')
      }

      this.$set(this.autoPost, "on", !this.autoPost.on);
    },
    updateAndApprove() {
      // 修改并通过
      if (this.posting) return

      const id = this.$route.query.r
      const title = this.topic
      const depart_id = this.selectedDep.id
      const depart_name = this.selectedDep.title
      const start = this.datePicker[0] ? common.stampToTime(this.datePicker[0]) : ''
      const end = this.datePicker[1] ? common.stampToTime(this.datePicker[1]) : ''
      const address = this.locate
      const reporters = this.formReporter(this.reporters)
      const remark = this.remark
      const base_class = this.formClass(this.bases)
      const sub_class = this.formClass(this.expands)
      const st_id = this.associate.id
      const required = common.allRequired([title, depart_id, start, end, address, reporters])

      if (!required) {
        this.$toast('必填项不可为空')
        return
      }

      const info = {
        iview_id: id,
        title: title,
        depart_id: depart_id,
        depart_name: depart_name,
        start: start,
        end: end,
        address: address,
        reporters: reporters,
        remark: remark,
        base_class: base_class,
        sub_class: sub_class,
        st_id: st_id,
        attachment_ids: this.attachments.map(a => a.file_id).join(',')
      }

      this.posting = true
      common.myFetch(apis.Itv_interview_edit, info)
      .then((r) => {
        if (r) {
          const checkInfo = {
            iview_id: id,
            status: 0
          }

          common.myFetch(apis.Itv_handle_interviews, checkInfo)
          .then((data) => {
            if (data) {
              const info = {
                msg: data,
                tip: '页面即将关闭'
              }

              this.$refs.successTip.open(info)
            }
          })
        } else {
          this.posting = false
        }
      })
    },
    searchReporters() {
      // 筛选记者
      this.reporters.forEach((i) => {
        this.$set(i, 'hide', true)
      })

      this.reporters.forEach((i) => {
        if (i.name.indexOf(this.reporter) > -1) {
          this.$set(i, 'hide', false)
        }
      })
    },
    toggleDepart(){
      if (this.disableDepart) return

      this.showDepart = !this.showDepart
    },
    getBaseCounter(d) {
      // 接收基础类数量
      this.matchResources(d, this.bases)
    },
    getSubCounter(d) {
      // 接收拓展类数量
      this.matchResources(d, this.expands)
    },
    matchResources(d, l) {
      // 将接收到的资源数量数据同步到数据模型
      l.forEach((i) => {
        if (d.name === i.rc_name) {
          i.num = d.value
        }
      })
    },
    getLink(t) {
      // 接收关联选题
      this.associate = t
    },
    selectReporter(r) {
      this.$set(r, 'selected', true)
      this.reporter = ''
      this.searchReporters()
      // this.focusInputing = false
    },
    unSelectReporter(r) {
      this.$set(r, 'selected', false)
    },
    selectdep(d) {
      this.selectedDep = d
      this.reporters = d.reporters
      this.showDepart = false
    },
    focusInput() {
      this.focusInputing = true
    },
    blurInput() {
      // 记者输入框失去焦点
      this.focusInputing = false
    },
    getLocate(l) {
      this.locate = l
    },
    closePops() {
      this.focusInputing = false
      this.showDepart = false
    },
    triggerUpload() {
      // 触发分片上传文件选择（input 由 Upload 类注入到 #itvUploadBtn）
      let btn = document.getElementById('itvUploadBtn')
      if (btn) btn.click()
    },
    initUploader() {
      // 初始化「仅图片」分片上传器，复用「我的素材」上传引擎，但进度在缩略图墙内渲染
      createImageUploader({
        id: 'itvUploadBtn',
        onReady: (list) => {
          // 文件已选中：限制最多 3 张，超额截断
          const remain = 3 - this.attachments.length
          if (list.length > remain) {
            this.$toast(`最多上传3张，已为您上传前${remain}张`)
          }
          list.slice(0, remain).forEach(f => {
            this.attachments.push({
              tid: f.tid,
              file_id: '',
              file_name: f.name,
              url: URL.createObjectURL(f.file),
              uploading: true,
              failed: false,
              token: '',
              progress: 0
            })
          })
          // 超过上限的文件：引擎已进入分片流程无法从队列清出，
          // 故对超额文件立即 cancelUpload 取消，避免静默上传浪费带宽
          if (this.itvUpload && list.length > remain) {
            list.slice(remain).forEach(f => this.itvUpload.cancelUpload(f.tid))
          }
        },
        onProgress: (res) => {
          let item = this.attachments.find(a => a.tid === res.tid)
          if (item) this.$set(item, 'progress', Math.min(99, res.progress | 0))
        },
        onComplete: (res) => {
          // 分片上传完成，传 token 调 addfiles 注册为采访附件，拿 file_id/file_url
          let item = this.attachments.find(a => a.tid === res.tid)
          if (item) this.$set(item, 'token', res.token)
          this.registerAttachment(res)
        },
        onError: (res) => {
          // 引擎层失败：分片可能未传完，token 不一定有；有 token 则通知后端清理
          this.$toast(`"${res.name || '图片'}"上传失败：${res.msg || '请重试'}`)
          if (res.token) cancelRemoteUpload(res.token)
          if (res.tid) this.removeAttachmentByTid(res.tid)
        },
        onCancel: (tid, token) => {
          // 引擎 cancelUpload 后触发：通知后端清理已上传分片，避免孤儿残留
          cancelRemoteUpload(token)
        }
      }).then(upload => {
        this.itvUpload = upload
      })
    },
    registerAttachment(res) {
      // 分片上传完成后调 addfiles 入库；myFetch 业务错误时不 reject 而是返回 null，
      // 故需用 data 真值判断成功，失败则进入可重试状态而非直接丢弃（避免孤儿分片）
      common.myFetch(apis.Itv_interview_addfiles, { token: res.token })
        .then(data => {
          let item = this.attachments.find(a => a.tid === res.tid)
          if (!item) return
          if (data && data.file_id) {
            this.$set(item, 'file_id', data.file_id)
            this.$set(item, 'file_name', data.file_name || res.name)
            if (data.file_url) {
              URL.revokeObjectURL(item.url)
              this.$set(item, 'url', data.file_url)
            }
            this.$set(item, 'uploading', false)
            this.$set(item, 'failed', false)
            this.$set(item, 'progress', 100)
          } else {
            // 入库失败：保留缩略图与 token，标记 failed 供用户点击重试
            this.$set(item, 'uploading', false)
            this.$set(item, 'failed', true)
            this.$toast(`图片"${res.name}"入库失败，可点击重试`)
          }
        })
        .catch(() => {
          // 仅网络层异常会走到这里
          let item = this.attachments.find(a => a.tid === res.tid)
          if (item) {
            this.$set(item, 'uploading', false)
            this.$set(item, 'failed', true)
          }
          this.$toast(`图片"${res.name}"入库失败，可点击重试`)
        })
    },
    retryRegister(i) {
      // 重试入库：针对 failed 状态的项重新调 addfiles
      let item = this.attachments[i]
      if (!item || !item.failed || !item.token) return
      this.$set(item, 'uploading', true)
      this.$set(item, 'failed', false)
      this.registerAttachment({ tid: item.tid, token: item.token, name: item.file_name })
    },
    removeAttachment(i) {
      // 删除附件：若正在上传，先取消分片上传
      let item = this.attachments[i]
      if (item && item.uploading && this.itvUpload) {
        this.itvUpload.cancelUpload(item.tid)
      }
      if (item && item.url && item.url.startsWith('blob:')) {
        URL.revokeObjectURL(item.url)
      }
      this.attachments.splice(i, 1)
    },
    removeAttachmentByTid(tid) {
      let idx = this.attachments.findIndex(a => a.tid === tid)
      if (idx > -1) {
        let item = this.attachments[idx]
        if (item.url && item.url.startsWith('blob:')) URL.revokeObjectURL(item.url)
        this.attachments.splice(idx, 1)
      }
    },
    openLink() {
      this.closePops()
      this.$refs.withTopic.open()
    },
    openLocation() {
      this.closePops()
      this.$refs.location.open()
    },
    getDetail() {
      const id = this.$route.query.r
      this.id = id
      const info = {
        iview_id: id
      }

      common.myFetch(apis.Itv_detail_edit, info)
      .then((data) => {
        this.matchData(data)

        if(data.is_output_topic == 1){
          this.autoPost.on = true
        }else{
          this.autoPost.on = false
        }

        if (!data.is_lock) {
          this.lock.interval = setInterval(() => {
            this.handleLock()
          }, this.lock.time)
        } else {
          this.lock.locker = data.lock_user_name
          this.lock.show = true
        }
      })
    },
    handleLock() {
      const info = {
        iview_id: this.$route.query.r
      }

      common.myFetch(apis.Itv_lock, info)
      .then((r) => {
        if (r) {
          console.log('lock', r)
        }
      })
    },
    handleUnlock() {
      const id = this.id || this.$route.query.r
      if (!id) return

      const info = {
        iview_id: id
      }

      common.myFetch(apis.Itv_unlock, info)
      .then((r) => {
        if (r) {
          console.log('unlock', r)
        }
      })
    },
    formReporter(d) {
      // 将记者数据组装为接口格式
      const r = []
      d.forEach(i => {
        if (i.selected) {
          r.push(`${i.id}#${i.name}`)
        }
      })

      return r.join(',')
    },
    formClass(d) {
      // 将资源（基础、拓展）数据组装为接口格式
      const r = []
      d.forEach(i => {
        r.push(`${i.rc_id}:${i.rc_name}:${i.num}`)
      })

      return r.join(';')
    },
    updateDetail() {
      if (this.posting) return

      const id = this.$route.query.r
      const title = this.topic
      const depart_id = this.selectedDep.id
      const depart_name = this.selectedDep.title
      const start = this.datePicker[0] ? common.stampToTime(this.datePicker[0]) : ''
      const end = this.datePicker[1] ? common.stampToTime(this.datePicker[1]) : ''
      const address = this.locate
      const reporters = this.formReporter(this.reporters)
      const remark = this.remark
      const base_class = this.formClass(this.bases)
      const sub_class = this.formClass(this.expands)
      const st_id = this.associate.id
      const required = common.allRequired([title, depart_id, start, end, address, reporters])

      if (!required) {
        this.$toast('必填项不可为空')
        return
      }

      const info = {
        iview_id: id,
        title: title,
        depart_id: depart_id,
        depart_name: depart_name,
        start: start,
        end: end,
        address: address,
        reporters: reporters,
        remark: remark,
        base_class: base_class,
        sub_class: sub_class,
        st_id: st_id,
        is_output_topic: this.autoPost.on ? 1 : 0,
        attachment_ids: this.attachments.map(a => a.file_id).join(',')
      }

      this.posting = true
      common.myFetch(apis.Itv_interview_edit, info)
      .then((data) => {
        if (data) {
          const info = {
            msg: data,
            tip: '页面即将关闭'
          }

          this.$refs.successTip.open(info)
        } else {
          this.posting = false
        }
      })
    },
    goBack() {
      // window.history.go(-1)
      
      window.close()
    },
    matchData(data) {
      this.has_topic_power = data.has_topic_power
      this.topicExist = data.topicExist
      this.enableAssociate = !!data.topicExist
      this.disableDepart = !data.depart_change
      this.showRelease = data.has_release
      this.showModify = data.has_update
      this.expands = data.sub_class
      this.remark = data.remark
      this.bases = data.base_class
      this.topic = data.iview_title
      this.locate = data.address
      this.reporters = data.reporters
      this.deps = data.departs
      this.datePicker = [new Date(data.start), new Date(data.end)]
      this.getLink({id: data.topic_id, title: data.topic_title})
      this.attachments = (data.attachment_info || []).map(a => ({
        file_id: a.file_id,
        url: a.file_url
      }))
      this.defaultDep()
    },
    defaultDep() {
      this.deps && this.deps.forEach((d) => {
        if (d.selected) {
          this.selectedDep = d
          this.reporters = d.reporters
        }
      })

      console.log(44, this.deps)
    }
  },
  mounted() {
    this.getDetail()
    this.initUploader()
  },
  beforeDestroy() {
    if (this.lock.interval) {
      clearInterval(this.lock.interval)
      this.handleUnlock()
    }
  }
}
</script>

<style lang="less" src="@assets/css/interview/editInterview.less" scoped></style>

<style lang="less" scoped>
.autoPost {
  position: absolute;
  top: 50%;
  right: 40px;
  transform: translateY(-50%);
  height: 40px;
  border-radius: 100px;
  border: 1px solid #dcdcdc;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #41B48C;
  cursor: pointer;
  box-sizing: border-box;
  padding: 0 20px;

  img {
    margin-right: 6px;
  }
}

.autoPostOn {
  border-color: #41B48C;
}

.uploadItem {
  height: auto !important;
  align-items: flex-start;

  .placeholder {
    visibility: hidden;
  }
}

.attachment {
  .attachmentTitle {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: #050F0F;
    line-height: 22px;
    margin-bottom: 20px;

    span {
      margin-left: 10px;
      font-weight: bold;
      font-size: 14px;
      color: #B9C3C3;
      line-height: 20px;
    }
  }

  .attachmentList {
    display: flex;
    flex-wrap: wrap;
  }

  .attachmentAdd {
    width: 80px;
    height: 80px;
    margin-right: 12px;
    margin-bottom: 12px;
    border-radius: 4px;
    background: #F3F5F6;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    i {
      display: block;
      width: 22px;
      height: 22px;
      background: url('../../assets/img/common/plusIcon.png') no-repeat;
      background-position: center center;
      background-size: 100% 100%;
    }
  }

  .attachmentItem {
    position: relative;
    width: 80px;
    height: 80px;
    margin-right: 12px;
    margin-bottom: 12px;

    > img:not(.del) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
    }

    .del {
      position: absolute;
      top: -7px;
      right: -7px;
      width: 14px;
      height: 14px;
      cursor: pointer;
      object-fit: contain;
    }

    .progressMask {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.45);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .progressBar {
        width: 56px;
        height: 4px;
        border-radius: 2px;
        background: rgba(255, 255, 255, 0.4);
        overflow: hidden;

        i {
          display: block;
          height: 100%;
          width: 0%;
          background: #41B48C;
          transition: width 0.2s ease;
        }
      }

      .progressText {
        margin-top: 6px;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 16px;
      }
    }

    .failMask {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.55);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .failIcon {
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        border-radius: 50%;
        background: #F56C6C;
        color: #FFFFFF;
        font-size: 13px;
        font-weight: bold;
      }

      .failText {
        margin-top: 4px;
        font-size: 11px;
        color: #FFFFFF;
        line-height: 14px;
        text-align: center;
      }
    }
  }

  .uploadMount {
    display: none;
  }
}
</style>
